import React from "react";
import { MapPin } from "lucide-react";

export function Logo({ className = "", onClick, size = "md", light = false }) {
  const text = size === "lg" ? "text-2xl" : "text-xl";
  return (
    <div
      onClick={onClick}
      data-testid="nf-logo"
      className={`flex items-center gap-2 cursor-pointer select-none ${className}`}
    >
      <div className="relative flex h-8 w-8 items-center justify-center rounded-xl bg-gradient-to-br from-emerald-500 to-indigo-600 shadow-sm">
        <MapPin className="h-4 w-4 text-white" strokeWidth={2.5} />
      </div>
      <span className={`font-display font-extrabold tracking-tight ${text} ${light ? "text-white" : "text-zinc-900"}`}>
        Near<span className="text-emerald-500">fluence</span>
      </span>
    </div>
  );
}
